import React from 'react'

export const Cell = ({ children, color, className }) => {
    return (
        <div
            className={`w-full flex items-center justify-between gap-6 py-1 px-2 h-10 ${className}`}
            style={{
                backgroundColor: color
            }}>
            {children}
        </div>
    );
};